<button *ngFor="let c of config; let index = index"
  kendoButton
  (click)="changeFilter(c, index)"
  [ngClass]="{ 'active': index === selectedFilter }"
>{{c.title}}</button>